module.exports = __webpack_public_path__ + "static/media/harsh.6ecc701f.png";